import React from "react";
import { Link } from "react-router-dom";

export default function ContactPage() {
  return (
    <main className="contact-page">
      <section className="contact-hero page-shell">
        <div className="contact-copy">
          <p className="eyebrow">START A CONVERSATION</p>
          <h1>What could your community make possible?</h1>
          <p>We are exploring how businesses can give customers a useful place to share, discover, and return. If you're thinking about a customer app, content workflow, or measured pilot, let's compare notes.</p>
          <Link className="button button-primary" to="/case-studies">Explore the concepts <span aria-hidden="true">↗</span></Link>
        </div>
        <aside className="contact-card">
          <span className="contact-card-mark" aria-hidden="true">n</span>
          <p className="eyebrow">FOUNDER</p>
          <h2>Venkata Martha</h2>
          <p>Founder</p>
          <div className="contact-location"><span aria-hidden="true">LOCATION</span><strong>Fremont, CA</strong></div>
        </aside>
      </section>
      <section className="contact-footnote">
        <div className="page-shell"><p>Early conversations are about fit and learning, not assumed commitments. Design partners, pilots, and measured outcomes remain targets.</p></div>
      </section>
    </main>
  );
}